/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import {
    GET_GOOGLE_PAY_CLIENT_ID,
    LOAD_GOOGLE_PAY_CLIENT_ID,
    CLEAR_GOOGLE_PAY_CLIENT_ID,
    PLACE_ORDER_GOOGLE_PAY,
    USE_ANOTHER_GOOGLE_PAY_ACCOUNT,
} from './GooglePay-ActionTypes';

export const getClientIdGooglePay = () => ({
    type: GET_GOOGLE_PAY_CLIENT_ID,
});

export const loadClientIdGooglePay = (clientId) => ({
    type: LOAD_GOOGLE_PAY_CLIENT_ID,
    data: clientId,
});

export const clearClientIdGooglePay = () => ({
    type: CLEAR_GOOGLE_PAY_CLIENT_ID,
});

export const placeOrderGooglePay = (data) => ({
    type: PLACE_ORDER_GOOGLE_PAY,
    data,
});

export const useAnotherUserGooglePayAccount = (data) => ({
    type: USE_ANOTHER_GOOGLE_PAY_ACCOUNT,
    data,
});

export default {};
